import { connect } from 'react-redux';
import { selectContentBannerImgUrl } from 'apps/invite-access/invite-access.selectors';
import { CoBrand } from './co-brand.view';

export const CoBrandContainer = connect(state => ({
  employerLogoUrl: selectContentBannerImgUrl(state),
}))(CoBrand);
